export { default } from './restriction-error-modal';
